import { red, yellow } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    background: 'linear-gradient(252.44deg, rgba(222, 225, 225, 0.1) 0%, #f4f4f4 100%), #ffffff'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    '&': {
                        textTransform: 'none',
                        boxShadow: 'none'
                    }
                },
                text: {
                    '&': {
                        fontWeight: 600
                    }
                },
                iconSizeSmall: {
                    '& > *:first-child': {
                        fontSize: 16
                    },
                    '&': {
                        marginRight: 4
                    }
                }
            }
        }
    },
    palette: {
        primary: {
            main: '#1a77d2',
            dark: '#454756',
            contrastText: '#F8F8FA'
        },
        secondary: {
            main: '#94ca85',
            contrastText: '#ffffff'
        },
        success: {
            main: '#94ca85',
            contrastText: '#ffffff'
        },
        warning: {
            main: yellow[700]
        },
        error: {
            main: red[500]
        }
    },
    typography: {
        fontFamily: 'Open Sans',
        fontWeightBold: 700,
        fontWeightMedium: 600,
        fontWeightRegular: 400
    }
});
